import { useQuery } from "@tanstack/react-query";

import {
  searchFastenerCatalog,
  type FastenerCatalogItem,
} from "../api/catalogs";
import type { FastenerBrandCode } from "../api/applications";

export function useFastenerCatalog(
  brand: FastenerBrandCode | null,
  q: string,
  enabled = true,
) {
  return useQuery<FastenerCatalogItem[]>({
    queryKey: ["catalogs", "fasteners", brand, q],
    queryFn: () =>
      searchFastenerCatalog({
        brand: brand as FastenerBrandCode,
        q: q || undefined,
        limit: 20,
      }),
    enabled: enabled && !!brand && brand !== "OTHER",
    staleTime: 60 * 1000,
  });
}
